import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-[#181518] text-[#F7F2EA]" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-14">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div className="max-w-md">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-icon.jpg" alt="Parrucchiere Vincente" className="h-11 w-11 rounded-full object-cover" />
            <span className="font-display text-xl font-bold">
              Parrucchiere <span className="text-[#D83A52] italic">Vincente</span>
            </span>
          </div>
          <p className="text-sm text-[#F7F2EA]/60 leading-relaxed">
            L'unica Agenzia di Marketing per Saloni da Parrucchiere che lavora a %.
          </p>
        </div>

        <div className="text-sm text-[#F7F2EA]/70 space-y-1.5" data-testid="footer-legal-info">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A6A1] mb-3">Informazioni legali</p>
          <p className="font-semibold text-[#F7F2EA]">BEETOO AGENCY S.R.L.</p>
          <p>Via dell'Industria 26/B – 34144 Trieste (TS)</p>
          <p>P.IVA / C.F.: 01275560322 · VAT: IT01275560322</p>
          <p>REA: TS-137733</p>
          <p>PEC: beetooagency@pec.it</p>
        </div>

        <div className="text-sm space-y-2.5">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A6A1] mb-3">Policy</p>
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="block text-[#F7F2EA]/70 hover:text-[#D83A52] transition-colors">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" data-testid="footer-cookie-link" className="block text-[#F7F2EA]/70 hover:text-[#D83A52] transition-colors">
            Cookie Policy
          </Link>
          <button
            data-testid="footer-manage-cookies-btn"
            onClick={() => window.dispatchEvent(new Event("pv-open-cookie-banner"))}
            className="block text-[#F7F2EA]/70 hover:text-[#D83A52] transition-colors"
          >
            Gestisci consenso cookie
          </button>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-[#F7F2EA]/10 text-xs text-[#F7F2EA]/40">
        © {new Date().getFullYear()} BeeToo Agency S.R.L. – Tutti i diritti riservati.
      </div>
    </div>
  </footer>
);
